import 'leaflet/dist/leaflet';

/**
 * Translate the controls for the map.
 *
 * @param control
 * @param label
 */
const translateControls = ( control, label ) => {
  control.ariaLabel = label;
  control.title = label;
}

const leafletMap = (id = 'map') => {

  // Fetch map data from the data attribute
  const el = document.getElementById( id );

  if (!el) {
    return;
  }

  const data = JSON.parse( el.getAttribute( 'data-map' ) );

  // Initialize the map.
  const map = L.map( id ).setView( [data.lat, data.lng], data.zoom );
  const {_zoomInButton, _zoomOutButton} = map.zoomControl;
  const {zoom_in, zoom_out} = window.vrgz_variables.map.controls;

  translateControls( _zoomInButton, zoom_in );
  translateControls( _zoomOutButton, zoom_out );


  // Add OpenStreetMap tiles.
  // Follow the OSM tile usage policy (https://operations.osmfoundation.org/policies/tiles/):
  // - use the canonical tile URL, without subdomains or query parameters;
  // - always send a Referer, even when the site sets a strict Referrer-Policy header,
  //   otherwise the tile servers respond with "Access blocked" tiles;
  // - no retina detection, OSM has no retina tiles and it would quadruple the amount of requests.
  L.tileLayer( 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    referrerPolicy: 'strict-origin-when-cross-origin',
    maxZoom: data.maxZoom || data.zoom || 16,
    minZoom: 6, // We want to limit the zoom level to 6, otherwise users can zoom out to much, prevents buggy behaviour.
  } ).addTo( map );


  // Sizes must always be 1:1. The icon will be scaled to the desired size.
  const iconSize = 48;
  const icon = L.divIcon( {
    className: 'custom-marker-icon',
    html: `<svg role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="${iconSize}px" viewBox="0 -960 960 960" width="${iconSize}px"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 400Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Z" /></svg>`,
    iconSize: [iconSize, iconSize],
    iconAnchor: [iconSize / 2, 0],
  } );

  // Add markers to the map.
  data?.markers.forEach( marker => {
    L.marker( [marker.lat, marker.lng], {icon: icon} )
      .addTo( map )
      .bindPopup( marker.label );
  } );
}

export default leafletMap;

